<template>
	<div class="w-full">
		<div class="w-full flex gap-8 mt-10" v-if="!loading">
			<div v-for="plan in plans" :key="plan.price_id" class="p-8 border rounded bg-gray-300 w-1/4">
				<div class="flex flex-col justify-between gap-12" style="text-align: start">
					<div class="flex flex-col">
						<div class="text-lg font-bold mb-4 h-12">{{ plan.product.name }}</div>
						<div>
							{{ $t('price') }}: {{ formatMoney(plan.amount) }} {{ plan.currency ? plan.currency.toUpperCase() : 'N/A' }} /
							{{ getPriceInterval(plan.interval, plan.interval_count ?? 1) }}
						</div>
						<div class="h-12" :class="{ invisible: plan.yearly_saved === 0 }">
							{{ $t('yearly_saved') }}:
							{{ formatMoney(plan.yearly_saved) }}
							{{ plan.currency ? plan.currency.toUpperCase() : 'N/A' }}
						</div>
					</div>
					<BaseButton @click="selectPlan(plan.price_id)" class="btn-blue">{{ $t('pick').toUpperCase() }}</BaseButton>
				</div>
			</div>
		</div>
		<div v-else />
	</div>
</template>
<script>
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import PaymentRepository from '@/api/repositories/PaymentRepository';
import Validate from '@/mixins/Validate';
import Authentication from '@/mixins/Authentication';
import Formatter from '@/mixins/Formatter';
import { loadStripe } from '@stripe/stripe-js';
import { getPriceInterval } from '@/helpers/Utils';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';

export default {
	name: 'OnboardingStripeData',
	mixins: [Validate, Authentication, Formatter],
	components: { LoadingSpinner, BaseButton },
	data() {
		return {
			loading: false,
			disableButton: false,
			stripe: null,
			stripeCustomer: null,
			plans: [],
			selectedPlanId: null, // Track the selected plan ID
			selectedProduct: null, // Track the selected product details
		};
	},
	async mounted() {
		if (this.isUserAllowedInLevel5or6 && this.isAuthenticatedUserInGroupAdmin) {
			this.loading = true;
			this.disableButton = true;
			await this.initializeStripe();
			await this.fetchStripeCustomer();
			await this.fetchPlans();

			if (this.stripeCustomer && this.stripeCustomer.subscriptions && this.stripeCustomer.subscriptions.length > 0) {
				this.$emit('checkStripeConnection');
				this.loading = false;
			} else {
				this.loading = false;
			}

			this.disableButton = false;
		}
	},
	methods: {
		getPriceInterval,
		async initializeStripe() {
			try {
				const stripePublicKey = process.env.VUE_APP_STRIPE_PK;
				if (!stripePublicKey) {
					throw new Error('Stripe public key is missing');
				}
				this.stripe = await loadStripe(stripePublicKey);
			} catch (error) {
				console.error('Stripe initialization error:', error);
			}
		},
		async fetchStripeCustomer() {
			try {
				const response = await PaymentRepository.getMe();
				this.stripeCustomer = response.data.data;
			} catch (error) {
				console.error(error);
			}
		},
		async fetchPlans() {
			try {
				const response = await PaymentRepository.getSalesProducts();
				this.plans = response.data.data;
			} catch (error) {
				console.error(error);
			}
		},
		async selectPlan(priceId) {
			this.selectedPlanId = priceId;
			try {
				const response = await PaymentRepository.checkout({ price_id: this.selectedPlanId });
				const { session_id } = response.data;

				// Redirect the user to the Stripe Checkout page
				const { error } = await this.stripe.redirectToCheckout({ sessionId: session_id });
				if (error) {
					console.error('Stripe Checkout redirect error:', error);
				}
			} catch (error) {
				console.error('Error during subscription checkout:', error);
			}
		},
		async manageSubscription() {
			try {
				const response = await PaymentRepository.portal();
				const { url } = response.data;

				// Redirect the user to the Stripe Billing Portal
				window.location.href = url;
			} catch (error) {
				console.error('Error accessing the billing portal:', error);
			}
		},
		formatDate(timestamp) {
			const date = new Date(timestamp);
			return date.toLocaleDateString();
		},
	},
};
</script>
